<template>
  <v-tabs
    v-if="topBar === 'tabs'"
    v-model="$formController.currentStep"
    :grow="true"
    :icons="true"
    show-arrows
  >        
    <v-tab
      v-for="(step, index) in $formController.steps"
      :key="index"
      :disabled="!$formController.stepEnabled(index) || $formController.loading"
    >
      <v-icon class="step-icon">{{step.icon}}</v-icon>
      <span v-if="isVisible(index)">{{ step.title }}</span>
    </v-tab>
  </v-tabs>

  <div
    v-else-if="topBar === 'fractional'"
    class="topbar-fractional"
  >
    <p>Step {{ $formController.currentStep + 1 }} of {{ $formController.totalSteps }}</p>
  </div>
</template>

<script>
export default {
  computed: {
    topBar() {
      return this.$wizardConfig.topBar
    }
  },
  methods: {
    isVisible(index) {
      //Always show if this is the current tab
      if (this.$formController.currentStep === index) {
        return true
      }
      //Config: Hide or show the tab titles which aren't selected
      if (this.topBar.persistentTabTitles) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
  .topbar-fractional {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .topbar-fractional p {
    margin-bottom: 0;
    padding: 12px 0;
  }
</style>